import { RequestStoreLocations, getAuthenticationHeaders } from '../../models/requests/RequestStoreLocations';

export interface ContactFormData {
  addressId: number;
  email: string;
  name: string;
  message: string;
}

class FormSubmissionService {
  private static instance: FormSubmissionService;
  private api!: RequestStoreLocations;

  private constructor() {
  }

  public init(aicoApiUrl: string, aicoApiKey: string) {
      if (aicoApiKey === '') {
        aicoApiKey = process.env.AICO_API_KEY || '';
      }
      if (aicoApiUrl === '') {
        aicoApiUrl = process.env.AICO_API_URL || '';
      }
      this.api = RequestStoreLocations.parse({
        baseUrl: aicoApiUrl,
        bearerToken: aicoApiKey
      });
    }

  public static getInstance(): FormSubmissionService {
    if (!FormSubmissionService.instance) {
      FormSubmissionService.instance = new FormSubmissionService();
    }
    return FormSubmissionService.instance;
  }

  /**
   * Submits the contact form data to the backend
   * @param formData Form data to submit
   * @returns Promise that resolves when the submission is complete
   */
  public async submitContactForm(formData: ContactFormData): Promise<{ message: string }> {
    try {

      const response = await fetch(`${this.api.baseUrl}store-locator-form-submission`, {
        method: 'POST',
        headers:getAuthenticationHeaders(this.api.bearerToken),
        body: JSON.stringify({ data: formData }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit form');
      }

      return await response.json();
    } catch (error) {
      console.error('[aico-store-locator] Error submitting contact form:', error);
      throw error;
    }
  }
}

export const formSubmissionService = FormSubmissionService.getInstance();
